<template>
  <div class="department-wrap style7 pb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="dp-content">
            <div class="content-title style1">
              <span>Our Department</span>
              <h2>Our Doctors Help You Awaken Talent & Take You Forward</h2>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content when looking at its layout. The point of
                using Lorem Ipsum is that amet has a moreorless normal
                distribution of letters as opposed dolor.
              </p>
            </div>

            <div class="feature-item-wrap">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-laser-3"></i>
                </div>
                <div class="feature-text">
                  <h5>Angelina Carventas Enlighten Sprituality</h5>
                  <p>
                    Vestibulum ac diam sit amet quam vehicula elemen tum sed sit
                    amet dui praesent sapien pellen tesque .
                  </p>
                </div>
              </div>

              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-laser-2"></i>
                </div>
                <div class="feature-text">
                  <h5>Anti-aging Facial Massage</h5>
                  <p>
                    Vestibulum ac diam sit amet quam vehicula elemen tum sed sit
                    amet dui praesent sapien pellen tesque.
                  </p>
                </div>
              </div>

              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-laser-1"></i>
                </div>
                <div class="feature-text">
                  <h5>The Mystical Miracle Of Dianna</h5>
                  <p>
                    Vestibulum ac diam sit amet quam vehicula elemen tum sed sit
                    amet dui praesent sapien pellen tesque.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="dp-img-wrap">
            <img
              class="dp-img-one bounce"
              src="../../assets/images/dp-img-6.jpg"
              alt="Image"
            />
            <img
              class="dp-img-two"
              src="../../assets/images/dp-img-7.jpg"
              alt="Image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurDepartment",
};
</script>